import HtmlNode from '../Extension/HtmlNode';
import InputInformation from './InputInformation';

export interface SelectItem {
  value: string;
  title?: string;
}

interface InputSelectProps {
  readonly title: string;
  readonly name: string;
  readonly id?: string;
  readonly value?: string;
  readonly options: SelectItem[];
  readonly placeholder?: string;
  readonly information?: string;
  readonly onChange: (e: Event) => void;
}

class InputSelect extends HtmlNode {
  private readonly props: InputSelectProps;
  constructor(element: HTMLElement | null, props: InputSelectProps) {
    super(element);

    this.props = props;
    this.render();
  }

  render() {
    const { id, options, name, value, title, placeholder, information, onChange } = this.props;
    this.node.innerHTML = `
      <div class="waykevaluation-input-label">
        <label for="wayke-estimated-mileage" class="waykevaluation-input-label__label">${title}</label>
      </div>
      <select
        class="waykevaluation-select"
        ${name ? `name="${name}"` : ''}
        ${id ? `id="${id}"` : ''}
      >
        ${
          placeholder ? `<option value="placeholder" disabled selected>${placeholder}</option>` : ''
        }
        ${options
          .map(
            (option) =>
              `<option value="${option.value}" ${
                option.value === value ? `selected="selected"` : ''
              }>${option.title || option.value}</option>`
          )
          .join('')}
      </select>
    `;

    this.node.querySelector('select')?.addEventListener('glossary.change', (e) => onChange(e));

    if (information) {
      new InputInformation(this.node.querySelector<HTMLElement>('.waykevaluation-input-label'), {
        information,
      });
    }
  }
}

export default InputSelect;
